import { render } from "./notification-log.vue?vue&type=template&id=63190e7d"
import script from "./notification-log.vue?vue&type=script&lang=js"
export * from "./notification-log.vue?vue&type=script&lang=js"

import "./notification-log.vue?vue&type=style&index=0&id=63190e7d&lang=css"

import exportComponent from "D:\\proyectos\\WSP\\Git_Luhott\\ambiental-cliente-frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__